var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPbsShop = function SvgPbsShop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 16 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M8.218.02c2.614 0 4.453 2.575 4.453 5.367v.008h1.447a1.88 1.88 0 0 1 1.867 2.114l-.871 6.96A4.033 4.033 0 0 1 11.112 18H4.839a4.033 4.033 0 0 1-4.005-3.559l-.82-6.945a1.882 1.882 0 0 1 1.868-2.101h1.883v-.008C3.765 2.595 5.605.02 8.218.02M1.882 7.007a.27.27 0 0 0-.266.3l.821 6.946a2.42 2.42 0 0 0 2.402 2.135h6.273a2.42 2.42 0 0 0 2.4-2.119l.872-6.96a.27.27 0 0 0-.266-.302H12.55v2.071a.815.815 0 1 1-1.63 0V7.007H5.376V9a.815.815 0 1 1-1.63 0V7.007zm6.336-5.413c-1.435 0-2.879 1.526-2.879 3.793v.008h5.758v-.008c0-2.268-1.443-3.793-2.879-3.793",
    clipRule: "evenodd"
  })));
};
export default SvgPbsShop;